// file upload statuses
const ENUM_OK = 'OK';
const ENUM_NONE = 'NONE';
const ENUM_FAIL = 'FAIL';
const ENUM_IMPORTING = 'IMPORTING';

export {
  ENUM_OK,
  ENUM_NONE,
  ENUM_FAIL,
  ENUM_IMPORTING,
};
